import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, map, Observable, of } from "rxjs";
import { ILoggedUserData } from "../../interfaces/common/loggedUserData";
import { IUserData } from "../../interfaces/administration/userData";
import { CalAngularService } from "@cvx/cal-angular";
import { UserService } from "../administration/user.service";

@Injectable({
  providedIn: "root",
})
export class LoggedUserService {
  private loggedUsername: string = "";
  private loggedUserDataSubject = new BehaviorSubject<ILoggedUserData | null>(
    null
  );
  public loggedUserData$: Observable<ILoggedUserData | null> =
    this.loggedUserDataSubject.asObservable();

  private loggedUserRoleSubject = new BehaviorSubject<string | null>(null);
  public loggedUserRole$: Observable<string | null> =
    this.loggedUserRoleSubject.asObservable();

  constructor(
    private userService: UserService,
    private authService: CalAngularService
  ) {}

  setLoggedUserData(data: ILoggedUserData): void {
    this.loggedUserDataSubject.next(data);
  }

  getLoggedUserData(): Observable<ILoggedUserData> {
    const currentValue = this.loggedUserDataSubject.getValue();

    if (currentValue !== null) {
      return this.loggedUserData$;
    } else {
      let accountInfo = this.authService.getAccount();
      this.loggedUsername = encodeURIComponent(accountInfo.username);
      return this.userService.getUserByEmail(this.loggedUsername).pipe(
        map((data) => {
          const userData: IUserData = data;
          const loggedUserData: ILoggedUserData = {
            id: userData.id,
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
          };
          this.setLoggedUserData(loggedUserData);
          return loggedUserData;
        })
      );
    }
  }

  getLoggedUserDataFromApi(): Observable<ILoggedUserData> {
    let accountInfo = this.authService.getAccount();
    this.loggedUsername = accountInfo.username;
    return this.userService.getUserByEmail(this.loggedUsername).pipe(
      map((data) => {
        const userData: IUserData = data;
        const loggedUserData: ILoggedUserData = {
          id: userData.id,
          firstName: userData.firstName,
          lastName: userData.lastName,
          email: userData.email,
        };

        this.setLoggedUserData(loggedUserData);
        return loggedUserData;
      })
    );
  }
}
